<script setup lang="ts">
import { computed } from 'vue';
import { InputGroup, Typography } from '@apparatix/library/core';
import DetailEditorBaseSingle from './DetailEditorBaseSingle.vue';
import type {
  ContactNotesSchema,
  ContactNotesErrors,
} from '@apparatix/schemas/ContactNote';
import { useContactStore } from '@apparatix/stores/useContactStore';

type Props = {
  contactNotes: ContactNotesSchema;
  noHeadingLabels?: boolean;
  errors?: ContactNotesErrors;
}

const props = defineProps<Props>();
const store = useContactStore();

const colLabel = computed(() => {
  if (props.noHeadingLabels) return undefined;
  return 'Contact Notes';
});

const note = computed(() => store.contactDetails.notes[0]?.note || '');

</script>
<template>
  <DetailEditorBaseSingle :col-header="colLabel">
    <template #col>
      <InputGroup>
        <Typography v-show="Boolean(note)" variant="form-label">
          {{ note }}
        </Typography>
        <Typography v-show="!Boolean(note)" muted variant="form-label">
          Empty
        </Typography>
      </InputGroup>
    </template>
  </DetailEditorBaseSingle>
</template>
